module.exports = __webpack_public_path__ + "img/-h-黄色.2733cb76.png";